import React from 'react';
import { connect } from 'react-redux';

import './ThanksPage.css';

import uiActions from '../actions/ui';
import Button from './Button';

class ThanksPage extends React.Component {
  render() {
    return (
      <div>
        <div className="thanks-overlay" />
        <div className="thanks-page">
          <div className="icon" />
          <h3>Thank you!</h3>
          <div className="message">
            We have received your design request and will be in touch soon!
            <br />
            <Button onClick={this.props.toggleThanksPage}>Search more</Button>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  null,
  { toggleThanksPage: uiActions.toggleThanksPage }
)(ThanksPage);



// WEBPACK FOOTER //
// ./src/components/ThanksPage.js